export interface ConfigurationSelection {
  configurationId: string;
  configurationName: string;
  versionId: string;
  versionNumber: number;
}

export interface CompareGroup {
  id: string;
  label: string;
  selections: ConfigurationSelection[];
}

export interface KpiDefinition {
  key: string;
  label: string;
  higherIsBetter: boolean;
  derivedFrom?: string;
}

export const KPI_DEFINITIONS: KpiDefinition[] = [
  { key: 'totalCalls', label: 'Total Calls', higherIsBetter: true },
  { key: 'bookingsMade', label: 'Bookings Made', higherIsBetter: true },
  { key: 'bookingsAttended', label: 'Bookings Attended', higherIsBetter: true },
  { key: 'paymentLinksSent', label: 'Payment Links Sent', higherIsBetter: true },
  { key: 'paymentLinksPaid', label: 'Payment Links Paid', higherIsBetter: true },
  { key: 'financeLinksSent', label: 'Finance Links Sent', higherIsBetter: true },
];

const GROUP_COLORS = [
  {
    bg: 'bg-blue-50 dark:bg-blue-950',
    text: 'text-blue-700 dark:text-blue-300',
    border: 'border-blue-200 dark:border-blue-800',
  },
  {
    bg: 'bg-emerald-50 dark:bg-emerald-950',
    text: 'text-emerald-700 dark:text-emerald-300',
    border: 'border-emerald-200 dark:border-emerald-800',
  },
  {
    bg: 'bg-purple-50 dark:bg-purple-950',
    text: 'text-purple-700 dark:text-purple-300',
    border: 'border-purple-200 dark:border-purple-800',
  },
  {
    bg: 'bg-amber-50 dark:bg-amber-950',
    text: 'text-amber-700 dark:text-amber-300',
    border: 'border-amber-200 dark:border-amber-800',
  },
  {
    bg: 'bg-rose-50 dark:bg-rose-950',
    text: 'text-rose-700 dark:text-rose-300',
    border: 'border-rose-200 dark:border-rose-800',
  },
  {
    bg: 'bg-cyan-50 dark:bg-cyan-950',
    text: 'text-cyan-700 dark:text-cyan-300',
    border: 'border-cyan-200 dark:border-cyan-800',
  },
  {
    bg: 'bg-indigo-50 dark:bg-indigo-950',
    text: 'text-indigo-700 dark:text-indigo-300',
    border: 'border-indigo-200 dark:border-indigo-800',
  },
  {
    bg: 'bg-orange-50 dark:bg-orange-950',
    text: 'text-orange-700 dark:text-orange-300',
    border: 'border-orange-200 dark:border-orange-800',
  },
];

export function getGroupColor(index: number) {
  return GROUP_COLORS[index % GROUP_COLORS.length];
}
